import { ProductModel } from '@/entities/product/model';
import { plainToInstanceRestaurantMenu } from '@/entities/restaurant/model/RestaurantMenu';
import type { RestaurantModel } from '@/entities/restaurant/model/RestaurantModel';
import { plainToInstanceRestaurant } from '@/entities/restaurant/model/RestaurantModel';
import { RestaurantsService } from '@/shared/api/service';

export class RestaurantApi {
  static async getRestaurantsList(companyId: number): Promise<RestaurantModel[]> {
    const response = await RestaurantsService.v1RestaurantsList({ companyId });
    return response.map((restaurant) => plainToInstanceRestaurant(restaurant));
  }

  static async getRestaurant(restaurantId: number): Promise<RestaurantModel> {
    const restaurant = await RestaurantsService.v1RestaurantsRetrieve({ restaurantId });
    return plainToInstanceRestaurant(restaurant);
  }

  static async getRestaurantMenu(restaurantId: number): Promise<ProductModel[]> {
    const menus = await RestaurantsService.v1RestaurantsMenuList({ restaurantId });
    return menus
      .map(plainToInstanceRestaurantMenu)
      .flatMap((menu) =>
        menu.items.map((p) => ({
          ...p,
          menuId: menu.id, 
        }))
      );
  }
}
